// extracted by mini-css-extract-plugin
export var active = "Navigation-module--active--96671";
export var altItem = "Navigation-module--alt-item--8cba2";
export var altLink = "Navigation-module--alt-link--3a9c2";
export var compact = "Navigation-module--compact--e5853";
export var iconArrow = "Navigation-module--icon-arrow--8d002";
export var iconGrid = "Navigation-module--icon-grid--d4fac";
export var item = "Navigation-module--item--02c07";
export var layout = "Navigation-module--layout--6fc13";
export var link = "Navigation-module--link--ebdfd";
export var list = "Navigation-module--list--0f76c";
export var listing = "Navigation-module--listing--c44ef";
export var modal = "Navigation-module--modal--e342d";
export var rightBounce = "Navigation-module--right-bounce--3cf65";
export var small = "Navigation-module--small--83888";
export var space = "Navigation-module--space--bc306";
export var subModal = "Navigation-module--sub-modal--72a0c";